import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66a28a2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  open: "",
  class: "popup popup--small js-popup is-opened"
}
const _hoisted_2 = { class: "popup__title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "popup__content" }
const _hoisted_6 = {
  key: 0,
  class: "custom-ul"
}
const _hoisted_7 = { class: "auth-btns" }
const _hoisted_8 = {
  class: "field-group",
  "data-group": "1"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "auth-email" }, "Email", -1))
const _hoisted_11 = {
  class: "field-group field-action",
  "data-group": "1"
}
const _hoisted_12 = { class: "field" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  class: "field-group",
  "data-group": "1"
}
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "auth-password" }, "Пароль", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "auth-password-confirm",
  id: "password-confirm-label"
}, "Подтвердите пароль", -1))
const _hoisted_18 = {
  class: "field-group field-action",
  "data-group": "1"
}
const _hoisted_19 = { class: "field" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerSmall = _resolveComponent("LoadingSpinnerSmall")!
  const _component_telegram_login_temp = _resolveComponent("telegram-login-temp")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showAuthModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          class: "popup-overlay"
        }))
      : _createCommentVNode("", true),
    (_ctx.showAuthModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("header", null, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                class: "popup__close js-popup-close",
                style: {"cursor":"pointer"}
              }, _hoisted_4)
            ], true)
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-auth-step-1", { 'is-active': _ctx.authStep === _ctx.AuthFlow.authStart }])
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('auth_modal.text_1')) + " ", 1),
              (_ctx.$t('auth_modal.text_2') !== '-')
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('auth_modal.text_2')), 1),
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('auth_modal.text_3')), 1),
                    _createElementVNode("li", null, _toDisplayString(_ctx.$t('auth_modal.text_4')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.widgetIsLoading)
                  ? (_openBlock(), _createBlock(_component_LoadingSpinnerSmall, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_telegram_login_temp, {
                  class: "btn",
                  mode: "callback",
                  "telegram-login": _ctx.botName,
                  onCallback: _ctx.authTelegram,
                  "request-access": "write",
                  size: "large",
                  radius: "4"
                }, null, 8, ["telegram-login", "onCallback"])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-auth-step-auth-1", { 'is-active': _ctx.authStep === _ctx.AuthFlow.inputEmail }])
            }, [
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitEmail && _ctx.submitEmail(...args)), ["prevent"])),
                class: "js-auth-login-form"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      placeholder: "Введите почту",
                      class: "field__text",
                      id: "auth-email",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitEmail && _ctx.submitEmail(...args))),
                      class: "btn btn-blue js-auth-login-password",
                      disabled: !_ctx.emailIsValid ? 'disabled' : null
                    }, "Продолжить", 8, _hoisted_13)
                  ])
                ])
              ], 32)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-auth-step-auth-2", { 'is-active': _ctx.authStep === _ctx.AuthFlow.inputPassword }])
            }, [
              _createElementVNode("form", {
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args)), ["prevent"])),
                class: "js-auth-login-form-password"
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      placeholder: "Введите пароль",
                      class: "field__text",
                      id: "auth-password",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.password) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ]),
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      placeholder: "Подтвердить пароль",
                      class: "field__text",
                      id: "auth-password-confirm",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.passwordConfirm) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.passwordConfirm]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("a", {
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitPassword && _ctx.submitPassword(...args))),
                      class: "btn btn-blue js-auth-login-finish",
                      disabled: !_ctx.passwordsAreValid ? 'disabled' : null
                    }, "Продолжить", 8, _hoisted_20)
                  ])
                ])
              ], 32)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-password-recovery-1", { 'is-active': _ctx.authStep === _ctx.AuthFlow.forgotPassword }])
            }, [
              _createTextVNode(" Ссылка для изменения пароля отправлена на почту "),
              _createElementVNode("strong", null, _toDisplayString(_ctx.email), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["auth-steps js-auth-steps js-reg-step-3", { 'is-active': _ctx.authStep === _ctx.AuthFlow.authFinish }])
            }, " Спасибо за регистрацию! 😎 ", 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}